import { atom } from "recoil";

export const officeLabel = atom({
  key: "officeLabel",
  default: "",
});
